export default "__VITE_ASSET__D9tL0GZp__"